<template>
	<div class="vstack gap-1">
		<div class="h5 fw-bold">Historial de propuestas</div>
		<table class="table table-sm lh-sm align-top">
			<tbody>
				<CustomerCommonProposalRow v-for="proposal in proposals" :key="proposal.id" :proposal="proposal" />
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		props: {
			proposals: Array
		}
	}
</script>